module.exports = __webpack_public_path__ + "static/media/bg_arguments_in_evidence.8f3e8aa3.jpg";